import { Stack, Button, Typography, TextField } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import TopNavigationButton from "../Components/View/Buttons/TopNavigationButton";
import TopMenu from "../Components/View/Menus/TopMenu";
import SearchPosition from "../Components/View/Forms/SearchPosition";
import SearchPositionResult from "../Components/View/General/SearchResults";
import NavigationTab from "../Components/View/Tab/NavigationTab/TabNavigation";
import useFetch from "../Service/Hooks/useFetch";
import { ApiUrls } from "../Components/Utils/globalVariables";
import debounce from "lodash.debounce";

export default function HomePage() {
    const [{}, doFetch] = useFetch(ApiUrls.GetANZSCO, "get", true)

    const [option, setOption] = useState([])
    const [code, setCode] = useState(null)
    const [search, setSearch] = useState("")



    const submitData = (event) => {
        setSearch(event.target.value)
    }

    const handleFetch = (search) => {
        doFetch({filter: search}, (res) => {
            setOption(res)
        })
    }

    const submitAnz = (event, value) => {
        setCode(value.id)
    }

    const debouncedFetch = useMemo(() => debounce(handleFetch, 1000), []);

    useEffect(() => {
        doFetch({filter: "برنامه"}, (res) => {
            setOption(res)
        })
    }, [])

    useEffect(() => {
        if(search.length > 2) {
            debouncedFetch(search)
        }
        if(search.length <= 2) {
            setOption([])
        }
    }, [search])


    return (
        <Stack spacing={6} sx={{pt: 6}} alignItems="center">
            <TopMenu />
            <Stack sx={{width: "100%"}}>
                <SearchPosition submitData={submitData} option={option} submitAnz={submitAnz} />
            </Stack>
            <Stack sx={{width: "100%"}} spacing={3}>
                <SearchPositionResult code={code} />
                <NavigationTab code={code} />
            </Stack>
        </Stack>
    )
}